import React, { useState } from 'react';
import Recipe from './Recipe';
import LoadingComponent from './LoadingComponent';
import api from '../api';

const dishPhotos = [
  'photo-1546833999-b9f581a1996d',
  'photo-1565557623262-b51c2513a641',
  'photo-1547592180-85f173990554',
  'photo-1601050690597-df0568f70950',
];

function DishList({ dishes, onBack }) {
  const [recipe, setRecipe]               = useState(null);
  const [loading, setLoading]             = useState(false);
  const [error, setError]                 = useState(null);

  const handleDishClick = async (dishName) => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get('/recipe', { params: { dishName } });
      if (!res.data) throw new Error('Network response was not ok');
      setRecipe(res.data);
    } catch (err) {
      setError('Failed to fetch the recipe. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingComponent />;

  return (
    <div className="content-panel">
      <button className="back-btn" onClick={recipe ? () => setRecipe(null) : onBack}>
        &#8592; {recipe ? 'Back to Dishes' : 'Back'}
      </button>

      {!recipe ? (
        <>
          <div className="section-header">
            <h2>Available Dishes</h2>
            <p>Click on any dish to view the full recipe and cooking instructions.</p>
          </div>

          {error && (
            <div style={{
              padding: '14px 18px',
              background: 'var(--color-danger-light)',
              border: '1px solid rgba(239,68,68,0.3)',
              borderRadius: 'var(--radius-md)',
              color: '#991B1B',
              fontSize: '0.9rem',
              marginBottom: '20px',
            }}>
              ⚠️ {error}
            </div>
          )}

          <div className="dish-list-grid">
            {dishes.map((dish, i) => (
              <button
                type="button"
                key={i}
                className="dish-list-item animate-fade-in-up"
                style={{ animationDelay: `${Math.min(i * 0.05, 0.5)}s` }}
                onClick={() => handleDishClick(dish)}
                aria-label={`View ${dish} recipe`}
              >
                <span className="dish-list-photo" aria-hidden="true">
                  <img
                    src={`https://images.unsplash.com/${dishPhotos[i % dishPhotos.length]}?auto=format&fit=crop&w=300&q=70`}
                    alt=""
                    width="300"
                    height="240"
                    loading="lazy"
                  />
                </span>
                {dish}
                <span className="dish-list-arrow" aria-hidden="true">↗</span>
              </button>
            ))}
          </div>
        </>
      ) : (
        <Recipe recipe={recipe} />
      )}
    </div>
  );
}

export default DishList;
